<template>
  <HorseTable
    id="HorseSailies"
    :headers="headers"
    title="Historique des saillies"
    :table-items="filteredSessionsByType"
  />
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { format } from 'date-fns';
import HorseTable from './HorseTable.vue';
import { filteredSessionPerContentType } from '../../../helpers/dataManager';

export default {
  components: { HorseTable },
  props: {
    horse: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const headers = ref([
      { text: 'Date', value: 'date', align: 'center', sortable: false },
      { text: 'Jument', value: 'horse', align: 'center', sortable: false },
      { text: 'Étalon', value: 'pattern', align: 'center', sortable: false },
      { text: 'Nº SIRE', value: 'sire_number', align: 'center', sortable: false },
      { text: 'Observation', value: 'observation', align: 'center', sortable: false }
    ]);
    const panel = ref(0);

    const filteredSessionsByType = computed(() => {
      const horseSessions = filteredSessionPerContentType(props.horse, 'type', ['SAILLIES']);

      return horseSessions.map(session => ({
        date: format(new Date(session.start_time * 1000), 'dd/MM/yyyy'),
        horse: session.mare || '--',
        pattern: session.standard || '--',
        sire_number: props.horse.horse_sire_number || '--',
        observation: session.observation || '--'
      }));
    });

    return { headers, panel, filteredSessionsByType };
  }
};
</script>
